import { useEffect, useRef, useState } from "react";
import { Trophy, X, Volume2, VolumeX } from "lucide-react";

let ctx;
function beep(freq, dur = 0.15, type = "sine", gain = 0.2) {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    const o = ctx.createOscillator(); const g = ctx.createGain();
    o.type = type; o.frequency.value = freq; g.gain.value = gain;
    o.connect(g); g.connect(ctx.destination); o.start();
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + dur); o.stop(ctx.currentTime + dur);
  } catch { /* audio blocked */ }
}
const fanfare = () => [523, 659, 784, 1047].forEach((f, i) => setTimeout(() => beep(f, 0.35, "triangle", 0.25), i * 120));

export function Podium({ board, onClose }) {
  const [step, setStep] = useState(-3);
  const [muted, setMuted] = useState(false);
  const m = useRef(muted); m.current = muted;
  const top = board.slice(0, 3);
  useEffect(() => {
    const seq = [-2, -1, 0, 1, 2, 3];
    const timers = seq.map((s, i) => setTimeout(() => {
      setStep(s);
      if (m.current) return;
      if (s < 0) beep(440, 0.12, "square", 0.12);
      else if (s === 0) beep(880, 0.3, "square", 0.15);
      else if (s < 3) beep(660 + s * 120, 0.25, "triangle", 0.2);
      else fanfare();
    }, 900 * (i + 1)));
    return () => timers.forEach(clearTimeout);
  }, []);
  const order = [top[1], top[0], top[2]];
  const heights = ["h-32", "h-44", "h-24"];
  const ranks = [2, 1, 3];
  const revealed = (r) => step >= (4 - r);
  return (
    <div className="fixed inset-0 z-50 bg-slate-950/95 text-white flex flex-col items-center justify-center p-6" data-testid="podium-overlay">
      <div className="absolute top-4 right-4 flex gap-2"><button data-testid="podium-mute" onClick={() => setMuted(!muted)} className="rounded-md border border-slate-700 p-2 hover:bg-slate-800">{muted ? <VolumeX className="h-5 w-5" /> : <Volume2 className="h-5 w-5" />}</button><button data-testid="podium-close" onClick={onClose} className="rounded-md border border-slate-700 p-2 hover:bg-slate-800"><X className="h-5 w-5" /></button></div>
      {step < 0 && <div className="text-center" data-testid="podium-countdown"><p className="text-xs uppercase tracking-[0.4em] text-slate-400 mb-4">Pengumuman juara dalam</p><p className="font-heading text-[10rem] leading-none font-bold text-amber-400 animate-pulse">{-step}</p></div>}
      {step >= 0 && (
        <div className="w-full max-w-3xl">
          <p className="text-center font-heading text-3xl sm:text-5xl font-bold mb-10 flex items-center justify-center gap-3"><Trophy className="h-10 w-10 text-amber-400" />Podium Juara</p>
          <div className="grid grid-cols-3 gap-4 items-end" data-testid="podium-stage">
            {order.map((p, i) => { const r = ranks[i]; const show = p && revealed(r); return (
              <div key={r} className="flex flex-col items-center">
                <div className={`transition-all duration-700 text-center mb-3 ${show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} data-testid={`podium-${r}`}>
                  <p className="font-heading text-xl sm:text-2xl font-bold">{p?.name || "—"}</p>
                  <p className="font-mono text-amber-300 text-lg">{p?.score}</p>
                  <p className="text-xs text-slate-400">{p?.correct}/{p?.total} benar</p>
                </div>
                <div className={`w-full rounded-t-xl grid place-items-start justify-center pt-3 font-heading text-4xl font-bold transition-all duration-700 ${heights[i]} ${r === 1 ? "bg-amber-400 text-slate-950" : r === 2 ? "bg-slate-300 text-slate-900" : "bg-amber-700 text-white"} ${show ? "opacity-100" : "opacity-20"}`}>{r}</div>
              </div>); })}
          </div>
          {step >= 3 && <p className="text-center text-slate-400 text-sm mt-8 animate-pulse">Selamat kepada para juara!</p>}
        </div>
      )}
    </div>
  );
}
